import { MutationTree } from 'vuex';
import { IFeedbackState } from '../stores/feedback.store';
import { IFeature } from '@/types/Feature';

export const mutationSetFeatures = 'setFeatures';
export const mutationSetFeaturesSuccess = 'setFeaturesSuccess';
export const mutationSetFeaturesFailed = 'setFeaturesFailed';

export const mutations: MutationTree<IFeedbackState> = {
  [mutationSetFeatures](state) {
    state.isLoading = true;
  },
  [mutationSetFeaturesSuccess](state, payload: IFeature[]) {
    state.isLoading = false;
    state.features = payload;
  },
  [mutationSetFeaturesFailed](state) {
    state.isLoading = false;
  },
};
